/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Support_TeamInputs */

const en_settings_tickets_support_team = /** @type {(inputs: Settings_Tickets_Support_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support Team`)
};

const zh_settings_tickets_support_team = /** @type {(inputs: Settings_Tickets_Support_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`客服团队`)
};

/**
* | output |
* | --- |
* | "Support Team" |
*
* @param {Settings_Tickets_Support_TeamInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_support_team = /** @type {((inputs?: Settings_Tickets_Support_TeamInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Support_TeamInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_support_team(inputs)
	return zh_settings_tickets_support_team(inputs)
});
export { settings_tickets_support_team as "settings.tickets.support_team" }